import type {
  QueryResult,
  VisualizationType,
  CountResult,
  BreakdownResult,
  TrendResult,
  ListResult,
} from '../../types/analytics.types';
import { BigNumberChart } from './BigNumberChart';
import { BarChartDisplay } from './BarChartDisplay';
import { LineChartDisplay } from './LineChartDisplay';
import { DonutChartDisplay } from './DonutChartDisplay';
import { TableChartDisplay } from './TableChartDisplay';

interface ChartRendererProps {
  result: QueryResult;
  visualizationType: VisualizationType;
}

export function ChartRenderer({ result, visualizationType }: ChartRendererProps) {
  const { data } = result;

  switch (visualizationType) {
    case 'big_number':
      if (data.type === 'count') {
        return <BigNumberChart data={data as CountResult} />;
      }
      return <div>Invalid data type for big number display</div>;

    case 'horizontal_bar':
      if (data.type === 'breakdown') {
        return <BarChartDisplay data={data as BreakdownResult} orientation="horizontal" />;
      }
      return <div>Invalid data type for bar chart</div>;

    case 'vertical_bar':
      if (data.type === 'breakdown') {
        return <BarChartDisplay data={data as BreakdownResult} orientation="vertical" />;
      }
      if (data.type === 'trend') {
        return <LineChartDisplay data={data as TrendResult} />;
      }
      return <div>Invalid data type for bar chart</div>;

    case 'line':
      if (data.type === 'trend') {
        return <LineChartDisplay data={data as TrendResult} />;
      }
      return <div>Invalid data type for line chart</div>;

    case 'donut':
      if (data.type === 'breakdown') {
        return <DonutChartDisplay data={data as BreakdownResult} />;
      }
      return <div>Invalid data type for donut chart</div>;

    case 'table':
      if (data.type === 'list') {
        return <TableChartDisplay data={data as ListResult} />;
      }
      return <div className="text-center py-8 text-muted-foreground">Invalid data type for table</div>;

    default:
      return <div>Unknown visualization type</div>;
  }
}
